export default [
    {
        id: 1,
        name: '1 campaña por mes'
    },
    {
        id: 2,
        name: '2 campañas en 1 mes'
    },
    {
        id: 3,
        name: '3 campañas en 2 meses'
    }
]
